import FormModal from '../components/forms/FormModal';
import FormShares from '../components/forms/FormShares';
import FormAttention from '../components/forms/FormAttention';
import FormAdditionalOrder from '../components/forms/FormAdditionalOrder';
import Hotels from '../components/Hotels.vue';
import HotelsHotTour from '../components/HotelsHotTour';
import HotelsEarlyBookingTour from '../components/HotelsEarlyBookingTour';

if (document.getElementById('main-modal')) {

  let vm = new Vue({
    el: '#main-modal',
    data() {
      return {
        modalData: window.modal,
      }
    },
    components: {
      FormModal
    },
  });

  $(document).on('click', '.btn-callback', function () {
    window.modal.type = 'callback';
    $('#main-modal').modal('show');
  });

  $(document).on('click', '.login-btn', function () {
    window.modal.type = 'login';
    $('#main-modal').modal('show');
  });

  $(document).on('click', '#show-order-all-form', function () {
    window.modal.type = 'all_order';
    $('#main-modal').modal('show');
  });

  $(document).on('click', '.btn-find-tour-modal', function () {
    window.modal.type = 'findtour';
    $('#main-modal').modal('show');
  });
}

if (document.getElementById('form-order')) {
  let vm = new Vue({
    el: '#form-order',
    components: {
      FormShares
    },
  });
}

if (document.getElementById('additional-form')) {
  let vm = new Vue({
    el: '#additional-form',
    components: {
      FormAdditionalOrder
    },
  });
}


if (document.getElementById('form-atten')) {
  let vm = new Vue({
    el: '#form-atten',
    components: {
      FormAttention
    },
  });
}


if (document.getElementById('hotels')) {
  new Vue({
    el: '#hotels',
    components: {
      Hotels
    },
  });
}

if (document.getElementById('hotels-hot-tour')) {
  new Vue({
    el: '#hotels-hot-tour',
    components: {
      HotelsHotTour
    },
  });
}

if (document.getElementById('hotels-early-booking-tour')) {
  new Vue({
    el: '#hotels-early-booking-tour',
    components: {
      HotelsEarlyBookingTour
    },
  });
}

if (document.getElementById('teamModal')) {



  let vm = new Vue({
    el: '#teamModal',
    data() {
      return {
        modalData: window.modal,
      }
    },
    components: {
      FormModal
    },
  });


  $(document).on('click', '.team-modal-button', function () {
    window.modal.type = 'ourTeam';
    window.modal.src = $(this).parents('.bl-position').find('.bl-left img').attr("src");
    $('#teamModal').modal('show');
  });

  if($('#teamModal').hasClass('show')) {
    console.log(7777);
  }




}




// WEBPACK FOOTER //
// ./resources/assets/js/snippets/callback.js